<template>
    <div id="modal-exit-confirm-set" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="container">
                        <div class="row mb-2">
                            <div class="col-6 pt-2">退場/取消</div>
                            <div class="col p-0">
                                <select class="form-control" v-model="opt">
                                    <option value="t">退場確定</option>
                                    <option value="e">退場取消</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pt-2">退場理由</div>
                            <div class="col p-0">
                                <select class="form-control" v-model="reason" :disabled="disableReason">
                                    <!-- <option value="null">-- 選択 --</option> -->
                                    <option v-for="opt in exitReasonList" :key="opt.val" :value="opt.val">{{opt.lab}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger" type="button" @click="exitConfirmSave">
                        設定する
                    </button>
                    <button class="btn btn-success" type="button" @click="hideThis">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getList, converVal} from 'pages/commons/form/selectList'
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                opt: 't',
                optInit: 't', // DB値
                reason: '1',
                reasonInit: '1', // DB値
                applyId: '',
                intvId: '',
                exitReasonList: this.makeExitReasonList()
            }
        },
        watch: {
            opt (opt) {
                if (opt == 'e') {
                    this.reason = null
                } else {
                    if (this.optInit == 'e') {
                        this.reason = '1'
                    } else {
                        this.reason = this.reasonInit
                    }
                }
            },
            getExitConfirmSaveStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            disableReason () {
               return this.opt == 't' ? false : true
            },
            ...mapGetters(['getExitConfirmSaveStatus'])
        },
        methods: {
            exitConfirmSave () {
                this.$store.dispatch('exitConfirmSave', {
                    intvId: this.intvId,
                    applyId: this.applyId,
                    opt: this.opt,
                    reason: this.reason
                })
            },
            openThis (item) {
                this.opt = item.apply_flg
                this.optInit = item.apply_flg
                this.reason = item.exit_reason
                this.reasonInit = item.exit_reason
                this.applyId = item.ai_id
                this.intvId = item.id
                $('#modal-exit-confirm-set').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-exit-confirm-set').modal('hide')
            },
            resetThis () {
                this.opt = 't'
                this.optInit = 't'
                this.reason = '1'
                this.reasonInit = '1'
                this.applyId = ''
                this.intvId = ''
            },
            makeExitReasonList () {
                return getList('exit_reason')
            },
        },
    }
</script>

<style></style>
